module.exports = __webpack_public_path__ + "img/1511338200.7daa8552.jpg";